import React from "react";
import styles from "./index.module.scss";
export default class Loading extends React.Component {
    render() {
        const { size = "7rem", className } = this.props;
        return (React.createElement("div", { className: `${styles.loading} ${className}`, style: { width: size, height: size } }));
    }
}
